<template>
  <path pid="0" d="M9 23a1 1 0 001-1v-3a3 3 0 00-3-3H4a1 1 0 000 2h3a1 1 0 011 1v3a1 1 0 001 1zM22 8h-3a1 1 0 01-1-1V4a1 1 0 00-2 0v3a3 3 0 003 3h3a1 1 0 000-2zM4 10h3a3 3 0 003-3V4a1 1 0 00-2 0v3a1 1 0 01-1 1H4a1 1 0 000 2zM22 16h-3a3 3 0 00-3 3v3a1 1 0 002 0v-3a1 1 0 011-1h3a1 1 0 000-2z"/>
</template>
